import React, { useState } from 'react';
import './header.scss';
import logo from './../../assets/biorad_logo.svg';
import {useNavigate} from 'react-router-dom';




//let initiated = false;

export default function Header({ showContent, isSignUp }) {
    let navigate = useNavigate();
    const onSubmit = (event) => {
        if(isSignUp)
        {
            navigate("/signup");
        }
        else 
        {
            navigate("/login");
        }
        
    }
    return (
        <div className="header" style={{"z-index": "99"}}>
            <div>
                <img className="logo" src={logo} alt="logo" />
            </div>
            <React.Fragment>
                <form onSubmit={onSubmit} className='signup'>
                    {isSignUp ?
                        <div class="o-form-button-bar"><input class="btn btn-primary" type="submit" value="Sign Up" id="signin-submit" data-type="save" /></div>
                        : <div class="o-form-button-bar"><input class="btn btn-primary" type="submit" value="Sign In" id="signin-submit" data-type="save" /></div>}
                </form>
            </React.Fragment>
        </div>
    )
}
